/**
 * Settings module translations - Tabs section
 */

const tabs = {
  peppol: "Peppol",
  vatRegistration: "Registro de IVA",
  salesTax: "Impuesto sobre las ventas",
  taxId: "ID fiscal",
  bankDetails: "Detalles bancarios",
  countrySpecifics: "Especificidades del país",
  registrationTracker: "Seguimiento de registros",
};

export default tabs;
